class Controller {
  constructor(Sections) {
    "ngInject";

    this.sections = Sections.settingsSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/settings/settings.controller.js